// extracted by css-extract-rspack-plugin
export default {"parametersHeading":"ParameterSettingsMenu-module__parametersHeading__LyYKk"};